module.exports = __webpack_public_path__ + "img/img-test-3.b7103cf3.png";